import React from 'react'
import { Route } from 'react-router-dom'
import BotConfiguration from '../../../../views/Dashboard/Configurations/BotConfiguration'

const Index = ({ match }) => (
  <div>
    <Route path={match.path} component={BotConfiguration} />
  </div>
)

export default Index
